import { createRoutine } from 'redux-saga-routines';

export const routine = createRoutine('IDEA_LANDING/SUBMIT_SECTION');
